// extracted by mini-css-extract-plugin
export default {"control":"control_control__9obHl","button":"control_button__o0fxo"};